/*
 *   File : manage-admin-role.js
 *   Author : https://evoqins.com
 *   Description : Manage admin role modal component
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// custom components
import { CustomSelectBox } from '../FormElements';
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { APIService } from '../../Service';

// custom style
import Color from "../../Style/color.scss";

const ManageAdminRoleModal = (props) => {

    const [roleList, setRoleList] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedRoleError, setSelectedRoleError] = useState("");

    const [loader, setLoader] = useState(false);
    const [roleLoader, setRoleLoader] = useState(true);

    useEffect(() => {
        if (props.data) {
            let admin_data = props.data?.admin_data;
            if (admin_data?.admin_type_id) {
                setSelectedRole({ value: admin_data?.admin_type_id, label: admin_data?.admin_type })
            } else {
                setSelectedRole(null);
            }
        }
    }, [props.data]);

    useEffect(() => {
        _getRoles();
    }, []);

    useEffect(() => {
        setSelectedRoleError("");
    }, [selectedRole]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("manage-admin-role-modal-close");
        button.click();
        props.handleClose();

    };

    // handle send email
    const _handleSubmit = () => {
        if (selectedRole === null) {
            setSelectedRoleError("Please select role");
        } else {
            _addSubAdmin();
        }
    };


    const _getRoles = () => {
        let is_post = true;
        let url = 'sub-admin/role/list';
        let request = {
            "page_num": 1,
            "page_size": 20,
            "is_active": true,
            "query": ""
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                const admins = response.data.data.map((admin) => ({
                    label: admin.name,
                    value: admin.id
                }));
                setRoleList(admins);
            } else {
                setRoleList([]);
            }
            setRoleLoader(false);
        })
    }

    // API - add sub admin
    const _addSubAdmin = () => {
        let is_post = true;
        let url = 'sub-admin/change-admin-role';
        let request = {
            "admin_id": Number(props.adminId),
            "role_id": selectedRole?.value || null
        }
        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(`The admin role has been successfully updated to ${selectedRole?.label ?? ""}`, { type: "success" });
                props.handleSuccess();
                _handleCloseModal();
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setLoader(false);
        })
    };



    return (
        <div className="modal fade"
            id="manage-admin-role-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-24`}>
                <span id='manage-admin-role-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-24 overflow-hidden border-0 e-bg-white-dark">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center pt-4 mx-1 px-4 pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            Manage Admin Role
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    <div className='modal-body pt-0 px-4  pb-4'>
                        <div className='px-1'>
                            <CustomSelectBox title='Role'
                                placeholder='Select role'
                                controlWidth='w-100'
                                required={true}
                                options={roleList}
                                // isMulti={true}
                                loader={roleLoader}
                                isSearchable={true}
                                borderColor={`0.031rem solid ${Color.arsenic}`}
                                padding="0.5rem 1rem"
                                value={selectedRole}
                                error={selectedRoleError}
                                onChange={(data) => setSelectedRole(data)} />
                        </div>
                    </div>

                    <div className='modal-footer border-0 pt-2 px-4 pb-4'>
                        <div className='row gx-3 w-100'>
                            <div className='col-6 ps-0'>
                                <SecondaryButton
                                    name="Cancel"
                                    paddingBlock="p-3"
                                    className="w-100"
                                    onClick={_handleCloseModal}
                                />

                            </div>
                            <div className='col-6 pe-0'>
                                <PrimaryButton
                                    name="Submit"
                                    className="w-100"
                                    loader={loader}
                                    onClick={_handleSubmit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ManageAdminRoleModal;